import { Injectable, EventEmitter, NgZone } from '@angular/core';
import { RecorderStore } from '../stores/recorder.store';
import { PlaybackConfig } from '../interfaces/playback-config';
import { WebAudioFactory } from '../factories/web-audio.factory';
import { MessageService } from '../../shared/services/message.service';

let instance: Player;

@Injectable()
export class Player {
  private audioContext: AudioContext;
  private bufferSource: AudioBufferSourceNode;
  private playbackConfig: PlaybackConfig;
  private recordData: Float32Array;

  playback = false;

  onPlaybackStart: EventEmitter<PlaybackConfig> = new EventEmitter();
  onPlaybackStop = new EventEmitter();
  onPlaybackFinish = new EventEmitter();
  onPlaybackEnd = new EventEmitter();

  constructor(
    private recorderStore: RecorderStore,
    private webAudioFactory: WebAudioFactory,
    private messageService: MessageService,
    private zone: NgZone
  ) {
    if (instance) {
      return instance;
    } else {
      instance = this;
    }
  }

  play(playbackConfig: PlaybackConfig) {
    this.playbackConfig = playbackConfig;

    this.getRecordData()
      .then(() => this.playRecordData());
  }

  private getRecordData(): Promise<Float32Array> {
    return this.recorderStore.getRecordData(this.playbackConfig.startPosition)
      .then(data => this.recordData = data);
  }

  private playRecordData() {
    if (false === this.recordData instanceof Float32Array) {
      return;
    }

    if (this.recordData.length === 0) {
      return;
    }

    if (this.audioContext === undefined) {
      this.audioContext = this.webAudioFactory.getAudioContext();
    }

    if (this.audioContext === undefined) {
      return this.messageService.showBrowserError();
    }

    const buffer: AudioBuffer = this.audioContext.createBuffer(1, this.recordData.length, 44100);
    buffer.copyToChannel(this.recordData, 0);

    this.bufferSource = this.audioContext.createBufferSource();
    this.bufferSource.onended = () => this.zone.run(() => this.finish());
    this.bufferSource.buffer = buffer;
    this.bufferSource.connect(this.audioContext.destination);
    this.bufferSource.start();

    this.playback = true;
    this.onPlaybackStart.emit(this.playbackConfig);
  }

  stop() {
    // To emit finish action only when playback was finished naturally
    this.bufferSource.onended = null;
    this.bufferSource.stop();

    this.playback = false;

    this.onPlaybackStop.emit();
    this.onPlaybackEnd.emit();
  }

  private finish() {
    this.playback = false;

    this.onPlaybackFinish.emit(this.playbackConfig);
    this.onPlaybackEnd.emit();

    if (this.playbackConfig.repeat) {
      this.playRecordData();
    } else {
      this.clearData();
    }
  }

  private clearData() {
    delete this.recordData;
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/entities/player.ts